var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "category-list-view" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t("chatbotv2.thereAreOnePages")) +
          "\n        "
      ),
      _c("strong", [_vm._v(_vm._s(_vm.category))]),
      _vm._v(
        "\n        " + _vm._s(_vm.$t("chatbotv2.categoryDesc")) + "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list" },
      _vm._l(_vm.pages, function (page) {
        return _c("div", { staticClass: "item" }, [
          _c(
            "div",
            {
              staticClass: "left",
              on: {
                click: function () {
                  return _vm.gotoPage(page)
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(page.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "url" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("link")]),
                _vm._v(
                  "\n                    " +
                    _vm._s(page.url) +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("a-switch", {
                attrs: { checked: _vm.isSelected(page) },
                on: {
                  click: function ($event) {
                    return _vm.toggle(page)
                  },
                },
              }),
            ],
            1
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }